import { render, staticRenderFns } from "./EditableValue.global.vue?vue&type=template&id=3a7a8477&scoped=true&lang=pug&"
import script from "./EditableValue.global.vue?vue&type=script&lang=ts&"
export * from "./EditableValue.global.vue?vue&type=script&lang=ts&"
import style0 from "./EditableValue.global.vue?vue&type=style&index=0&id=3a7a8477&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a7a8477",
  null
  
)

export default component.exports